export default __webpack_public_path__ + "static/media/flag-guatemala.0263b948.svg";